import { Pipe, PipeTransform } from '@angular/core';
import { LodashService } from '@nx-customer-apps/shared/services';

@Pipe({
    name: 'isNil',
    standalone: false
})
export class IsNilPipe implements PipeTransform {
    transform(value: unknown): boolean {
        return LodashService.isNil(value);
    }
}
